export default (state, action) => {
  switch (action.type) {
    case 'TOGGLE_DRAWER':
      return {
        ...state,
        drawerState: action.payload
      }
    default:
      return state
  }
}
